/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementActionType } from './SupplementActionType';
import {
    SupplementActionTypeFromJSON,
    SupplementActionTypeFromJSONTyped,
    SupplementActionTypeToJSON,
    SupplementActionTypeToJSONTyped,
} from './SupplementActionType';
import type { JustificationSource } from './JustificationSource';
import {
    JustificationSourceFromJSON,
    JustificationSourceFromJSONTyped,
    JustificationSourceToJSON,
    JustificationSourceToJSONTyped,
} from './JustificationSource';

/**
 * Individual justification in a supplement (one per match group or unmatched line item)
 * @export
 * @interface SupplementJustification
 */
export interface SupplementJustification {
    /**
     * Unique justification ID
     * @type {number}
     * @memberof SupplementJustification
     */
    readonly id: number;
    /**
     * ID of the parent supplement
     * @type {number}
     * @memberof SupplementJustification
     */
    supplementId: number;
    /**
     * ID of the associated match group (mutually exclusive with lineItemId)
     * @type {number}
     * @memberof SupplementJustification
     */
    lineItemMatchGroupId?: number | null;
    /**
     * ID of the associated unmatched line item (mutually exclusive with lineItemMatchGroupId)
     * @type {number}
     * @memberof SupplementJustification
     */
    lineItemId?: number | null;
    /**
     * 
     * @type {SupplementActionType}
     * @memberof SupplementJustification
     */
    actionType: SupplementActionType;
    /**
     * Amount requested for this justification in cents
     * @type {number}
     * @memberof SupplementJustification
     */
    amountRequestedCents?: number | null;
    /**
     * AI confidence score for this justification (0.0 to 1.0)
     * @type {number}
     * @memberof SupplementJustification
     */
    confidenceScore?: number | null;
    /**
     * Justification text
     * @type {string}
     * @memberof SupplementJustification
     */
    justificationText?: string | null;
    /**
     * 
     * @type {JustificationSource}
     * @memberof SupplementJustification
     */
    justificationSource?: JustificationSource;
    /**
     * AI-generated reasoning for this justification
     * @type {string}
     * @memberof SupplementJustification
     */
    aiReasoning?: string | null;
    /**
     * Title of the codebook reference
     * @type {string}
     * @memberof SupplementJustification
     */
    codeBookTitle?: string | null;
    /**
     * Chapter within the codebook
     * @type {string}
     * @memberof SupplementJustification
     */
    chapter?: string | null;
    /**
     * Relevant snippet from the codebook
     * @type {string}
     * @memberof SupplementJustification
     */
    snippet?: string | null;
    /**
     * ID of the user who created this justification
     * @type {number}
     * @memberof SupplementJustification
     */
    readonly createdBy?: number | null;
    /**
     * When the justification was created
     * @type {Date}
     * @memberof SupplementJustification
     */
    readonly createdAt?: Date;
    /**
     * When the justification was last updated
     * @type {Date}
     * @memberof SupplementJustification
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the SupplementJustification interface.
 */
export function instanceOfSupplementJustification(value: object): value is SupplementJustification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('supplementId' in value) || value['supplementId'] === undefined) return false;
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    return true;
}

export function SupplementJustificationFromJSON(json: any): SupplementJustification {
    return SupplementJustificationFromJSONTyped(json, false);
}

export function SupplementJustificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementJustification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'supplementId': json['supplementId'],
        'lineItemMatchGroupId': json['lineItemMatchGroupId'] == null ? undefined : json['lineItemMatchGroupId'],
        'lineItemId': json['lineItemId'] == null ? undefined : json['lineItemId'],
        'actionType': SupplementActionTypeFromJSON(json['actionType']),
        'amountRequestedCents': json['amountRequestedCents'] == null ? undefined : json['amountRequestedCents'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'justificationText': json['justificationText'] == null ? undefined : json['justificationText'],
        'justificationSource': json['justificationSource'] == null ? undefined : JustificationSourceFromJSON(json['justificationSource']),
        'aiReasoning': json['aiReasoning'] == null ? undefined : json['aiReasoning'],
        'codeBookTitle': json['codeBookTitle'] == null ? undefined : json['codeBookTitle'],
        'chapter': json['chapter'] == null ? undefined : json['chapter'],
        'snippet': json['snippet'] == null ? undefined : json['snippet'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function SupplementJustificationToJSON(json: any): SupplementJustification {
    return SupplementJustificationToJSONTyped(json, false);
}

export function SupplementJustificationToJSONTyped(value?: Omit<SupplementJustification, 'id'|'createdBy'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supplementId': value['supplementId'],
        'lineItemMatchGroupId': value['lineItemMatchGroupId'],
        'lineItemId': value['lineItemId'],
        'actionType': SupplementActionTypeToJSON(value['actionType']),
        'amountRequestedCents': value['amountRequestedCents'],
        'confidenceScore': value['confidenceScore'],
        'justificationText': value['justificationText'],
        'justificationSource': JustificationSourceToJSON(value['justificationSource']),
        'aiReasoning': value['aiReasoning'],
        'codeBookTitle': value['codeBookTitle'],
        'chapter': value['chapter'],
        'snippet': value['snippet'],
    };
}

